/*!
 * Copyright © 2018-2020. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Component, ChangeDetectionStrategy, Input, EventEmitter, Output } from '@angular/core';

import { IMapContextMenuPermissions, WorkOrderMarkerInfo, LatLng, IMapContextMenuData } from '../../../core/models';

@Component({
  selector: 'fm-work-order-menu-container',
  templateUrl: './work-order-menu-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkOrderMenuContainerComponent {
  @Input()
  public menuData: IMapContextMenuData<WorkOrderMarkerInfo>;

  @Input()
  public userPermissions: IMapContextMenuPermissions;

  @Output()
  public closed: EventEmitter<void> = new EventEmitter();

  @Output()
  public findNearestClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public zoomToClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public streetViewClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public editWorkOrderClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public workOrderDetailsClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public workOrderStatusHistoryClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public getDirectionToClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public getDirectionFromClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public locationToGarminClicked: EventEmitter<LatLng> = new EventEmitter();

  @Output()
  public copyCoordinatesClicked: EventEmitter<string> = new EventEmitter();

  public onMenuClosed(): void {
    this.closed.emit();
  }

  public onFindNearestClicked(): void {
    this.findNearestClicked.emit();
    this.closed.emit();
  }

  public onZoomToClicked(): void {
    this.zoomToClicked.emit();
    this.closed.emit();
  }

  public onStreetViewClicked(): void {
    if (this.menuData.streetViewAvailable) {
      this.streetViewClicked.emit();
      this.closed.emit();
    }
  }

  public onEditWorkOrderClicked(): void {
    this.editWorkOrderClicked.emit();
    this.closed.emit();
  }

  public onWorkOrderDetailsClicked(): void {
    this.workOrderDetailsClicked.emit();
    this.closed.emit();
  }

  public onWorkOrderStatusHistoryClicked(): void {
    this.workOrderStatusHistoryClicked.emit();
    this.closed.emit();
  }

  public onGetDirectionToClicked(): void {
    this.getDirectionToClicked.emit();
    this.closed.emit();
  }

  public onGetDirectionFromClicked(): void {
    this.getDirectionFromClicked.emit();
    this.closed.emit();
  }

  public onLocationToGarminClicked(): void {
    this.locationToGarminClicked.emit(this.menuData.clickLatLng);
    this.closed.emit();
  }

  public onCopyCoordinates(coordinatesToCopy: string): void {
    this.copyCoordinatesClicked.emit(coordinatesToCopy);
  }
}
